import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import apiCep from '../../api/apiCep';
import { getTotem } from '../../api/apiFactory';
import {
  fetchBairros, fetchEscolaridades, fetchEstadosTurismo, fetchFicouSabendo,
  fetchSolicitanteCampos, postCadastrarSolicitante, fetchCidadesTurismo, fetchSolicitanteCamposTotem, postCadastrarSolicitanteTotem,
  fetchEscolasJuizDeFora,
} from '../../api/endpoints';
import { desfazerBairro, selectBairroTotem } from '../../app/slices/bairroTotemSlice';
import { desfazerCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerComoSoube, selectComoSoubeTotem } from '../../app/slices/comoSoubeTotemSlice';
import { desfazerEscolaridade, selectEscolaridadeTotem } from '../../app/slices/escolaridadeTotemSlice';
import { desfazerConexao, fetchLogin } from '../../app/slices/loginSlice';
import {
  abrirModalBairro, abrirModalComoSoube, abrirModalEscolaridade, abrirModalSexo,
  selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria, desfazerSecretaria } from '../../app/slices/secretariasSlice';
import { desfazerSexo, selectSexoTotem } from '../../app/slices/sexoTotemSlice';
import {
  Alerta,
  Container, Divisor, FormFooter, Interno, Linha, Titulo,
} from '../../styles/base';
import {
  cep, cnpj, cpf, date, email, isCNPJ, name, number, rg, sus, tel,
} from '../../util/mascaras';
import { replaceEspeciais } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import { LinhaForm, LinhaFormTotem } from '../FormControl/FormControlEstilo';

const defaultValues = {
  Solicitante: '',
  SolicitanteSocial: '',
  Turista: 'N',
  IdEstadoTurista: '',
  IdCidadeTurista: '',
  BairroTurista: '',
  CEP: '',
  Endereco: '',
  Numero: '',
  Complemento: '',
  Telefone01: '',
  Telefone02: '',
  Telefone03: '',
  Sexo: '',
  IdGrauEscolaridade: '',
  RG: '',
  CPFCNPJ: '',
  Email: '',
  Palavra: '',
  PalavraConfirmacao: '',
  IdComoFicouSabendo: '',
  cartaoSus: '',
  CoronavirusRendaMensal: '',
  CoronavirusQuantosMembrosRecebemBolsaFamilia: '',
  CoronavirusQuantosDiasSemTrabalhar: '',
  CoronavirusQuantosMembrosPossuemAtividadeProdutiva: '',
  CoronavirusQuantidadeMembrosFamilia: '',
  CoronavirusTrabalhoRegistrado: '',
  ReceberNews: '',
  ConselhoOuvidoria: '',
  TermosAplicativo: '',
  // Juiz de Fora
  CPFResponsavel: '',
  DataInicio: '',
  DataTermino: '',
  DiasLetivos: '',
  Estudante: 'N',
  Justificativa: '',
  Linhas: '',
  MaiorIdade: 'N',
  NivelEnsino: '',
  NomeInstituicao: '',
  NomeResponsavel: '',
  Periodo: '',
  RedeEnsino: '',
  // end: Juiz de fora
};

const bool = [
  {
    Id: 'S',
    Campo: 'Sim',
  },
  {
    Id: 'N',
    Campo: 'Não',
  },
];

const boolSexo = [
  {
    Id: 'M',
    Campo: 'Masculino',
  },
  {
    Id: 'F',
    Campo: 'Feminino',
  },
  {
    Id: 'O',
    Campo: 'Outros',
  },
];

// Juiz de Fora
const boolNivelEnsino = [
  {
    Id: '1',
    Campo: 'Educação Infantil',
  },
  {
    Id: '2',
    Campo: 'Ensino Fundamental',
  },
  {
    Id: '3',
    Campo: 'Ensino Médio',
  },
  {
    Id: '4',
    Campo: 'Educação Profissional Técnica de Nível Médio',
  },
  {
    Id: '5',
    Campo: 'Educação de Jovens e Adultos (EJA)',
  },
  {
    Id: '6',
    Campo: 'Educação Profissional e Tecnológica',
  },
  {
    Id: '7',
    Campo: 'Ensino Superior',
  },
];

// Juiz de Fora
const boolPeriodoEstudo = [
  {
    Id: '1',
    Campo: 'Matutino',
  },
  {
    Id: '2',
    Campo: 'Vespertino',
  },
  {
    Id: '3',
    Campo: 'Noturno',
  },
  {
    Id: '4',
    Campo: 'Integral',
  },
];

// Juiz de Fora
const boolRedeEnsino = [
  {
    Id: 'Municipal',
    Campo: 'Municipal',
  },
  {
    Id: 'Estadual',
    Campo: 'Estadual',
  },
  {
    Id: 'Federal',
    Campo: 'Federal',
  },
  {
    Id: 'Outros',
    Campo: 'Outros',
  },
];

// Juiz de Fora
const checkDiasSemana = [
  {
    Id: '1',
    Campo: 'Segunda-feira',
  },
  {
    Id: '2',
    Campo: 'Terça-feira',
  },
  {
    Id: '3',
    Campo: 'Quarta-feira',
  },
  {
    Id: '4',
    Campo: 'Quinta-feira',
  },
  {
    Id: '5',
    Campo: 'Sexta-feira',
  },
  {
    Id: '6',
    Campo: 'Sábado',
  },
];

const coronaNumeros = [
  {
    Id: '0',
    Campo: '0',
  },
  {
    Id: '1',
    Campo: '1',
  },
  {
    Id: '2',
    Campo: '2',
  },
  {
    Id: '3',
    Campo: '3',
  },
  {
    Id: '4',
    Campo: '4',
  },
  {
    Id: '5',
    Campo: '5',
  },
  {
    Id: '6',
    Campo: '6',
  },
  {
    Id: '7',
    Campo: '7',
  },
  {
    Id: '8',
    Campo: '8',
  },
  {
    Id: '9',
    Campo: '9',
  },
  {
    Id: '10',
    Campo: '10',
  },
  {
    Id: '11',
    Campo: '11',
  },
  {
    Id: '12',
    Campo: '12',
  },
  {
    Id: '13',
    Campo: '13',
  },
  {
    Id: '14',
    Campo: '14',
  },
  {
    Id: '15',
    Campo: '15',
  },
  {
    Id: '16',
    Campo: '16',
  },
  {
    Id: '17',
    Campo: '17',
  },
  {
    Id: '18',
    Campo: '18',
  },
  {
    Id: '19',
    Campo: '19',
  },
  {
    Id: '20',
    Campo: '20',
  },
];

const FormularioUsuarioCadastro = () => {
  const [listaEstadosTurismo, setListaEstadosTurismo] = useState(null);
  const [listaCidadesTurismo, setListaCidadesTurismo] = useState(null);
  const [listaCampos, setListaCampos] = useState(null);
  const [listaBairros, setListaBairros] = useState(null);
  const [listaEscolaridades, setListaEscolaridades] = useState(null);
  const [listaFicouSabendo, setListaFicouSabendo] = useState(null);
  const [values, setValues] = useState(defaultValues);
  const [carregando, setCarregando] = useState(false);
  const [tipoCampoSenha, setTipoCampoSenha] = useState('senha');
  const [tipoCampoConfirmacaoSenha, setTipoCampoConfirmacaoSenha] = useState('senha');

  const dispatch = useDispatch();
  const alert = useAlert();
  const history = useHistory();

  const dadosCidade = useSelector(selectCidade);
  const dadosModal = useSelector(selectModal);

  const { bairroTotem } = useSelector(selectBairroTotem);
  const { sexoTotem } = useSelector(selectSexoTotem);
  const { escolaridadeTotem } = useSelector(selectEscolaridadeTotem);
  const { comoSoubeTotem } = useSelector(selectComoSoubeTotem);

  // Juiz de fora - INFORMAÇÕES DA INSTITUIÇÃO DE ENSINO
  const [juizDeFora, setJuizDeFora] = useState(false);
  const [checkCreditosDiarios, setCheckCreditosDiarios] = useState(false);
  const [listaInstituicaoEnsino, setListaInstituicaoEnsino] = useState(null);

  useEffect(() => {
    if (dadosCidade && dadosCidade.data && dadosCidade.data.idCidade === '2368') {
      setJuizDeFora(true);
      fetchEscolasJuizDeFora().then(setListaInstituicaoEnsino);
    }
    Promise.all([
      getTotem() === 'true' ? fetchSolicitanteCamposTotem() : fetchSolicitanteCampos(),
      fetchBairros(),
      fetchEscolaridades(),
      fetchFicouSabendo(),
      fetchEstadosTurismo(),
    ]).then(([dadosSolicitanteCampos, dadosBairros, dadosEscolaridades,
      dadosFicouSabendo, dadosEstadosTurismo]) => {
      setListaCampos(dadosSolicitanteCampos);
      setListaBairros(dadosBairros);
      setListaEscolaridades(dadosEscolaridades);
      setListaFicouSabendo(dadosFicouSabendo);
      setListaEstadosTurismo(dadosEstadosTurismo);
    });
    dispatch(desfazerBairro());
    dispatch(desfazerComoSoube());
    dispatch(desfazerSexo());
    dispatch(desfazerEscolaridade());
  }, []);

  useEffect(() => {
    setValues({ ...values, IdBairro: bairroTotem && bairroTotem.bairroId });
  }, [bairroTotem]);

  useEffect(() => {
    setValues({ ...values, IdSexo: sexoTotem && sexoTotem.sexoId });
  }, [sexoTotem]);

  useEffect(() => {
    setValues({ ...values, IdEscolaridade: escolaridadeTotem && escolaridadeTotem.escolaridadeId });
  }, [escolaridadeTotem]);

  useEffect(() => {
    setValues({ ...values, IdComoSoube: comoSoubeTotem && comoSoubeTotem.comoSoubeId });
  }, [comoSoubeTotem]);

  // Juiz de Fora
  useEffect(() => {
    if (values.Estudante !== 'S') {
      setCheckCreditosDiarios(false);

      setValues({
        ...values,
        CPFResponsavel: '',
        DataInicio: '',
        DataTermino: '',
        DiasLetivos: '',
        Estudante: 'N',
        Justificativa: '',
        Linhas: '',
        MaiorIdade: 'N',
        NivelEnsino: '',
        NomeInstituicao: '',
        NomeResponsavel: '',
        Periodo: '',
        RedeEnsino: '',
      });
    }
  }, [values.Estudante]);

  // Juiz de Fora
  useEffect(() => {
    // Se o usuário tiver entrado na página de cadastro através do botão de "Passe Livre Estudantil" (juiz de fora), seja na página inicial ou na ouvidoria, irá setar Estudante como 'S' por padrão
    if (dadosModal && dadosModal.secretaria && dadosModal.secretaria.idSecretaria === '10534' && dadosModal.origem === 'manifestacao') {
      setValues({ ...values, Estudante: 'S' });
    }
  }, []);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  if (!listaCampos || !listaFicouSabendo
    || !listaEscolaridades || !listaBairros || !listaEstadosTurismo) {
    return (
      <Carregar />
    );
  }

  if (listaCampos.Error
    || listaFicouSabendo.Error
    || listaEscolaridades.Error
    || listaBairros.Error
    || listaEstadosTurismo.Error) {
    history.push('/');
    dispatch(desfazerConexao());
    dispatch(desfazerCidade());
    dispatch(desfazerSecretaria());
    return (
      <Carregar />
    );
  }

  const emailCampo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Email');
  const idComoFicouSabendo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'IdComoFicouSabendo');
  const idGrauEscolaridade = listaCampos.find(({ NomeCampo }) => NomeCampo === 'IdGrauEscolaridade');
  const sexo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Sexo');
  const dataNascimento = listaCampos.find(({ NomeCampo }) => NomeCampo === 'DataNascimento');
  const rgCampo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'RG');
  const cpfcnpj = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CPFCNPJ');
  const endereco = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Endereco');
  const numero = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Numero');
  const complemento = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Complemento');
  const cepCampo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CEP');
  const telefone01 = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Telefone01');
  const telefone02 = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Telefone02');
  const telefone03 = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Telefone03');
  const coronavirusRendaMensal = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusRendaMensal');
  const coronavirusQuantosMembrosRecebemBolsaFamilia = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusQuantosMembrosRecebemBolsaFamilia');
  const coronavirusQuantosDiasSemTrabalhar = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusQuantosDiasSemTrabalhar');
  const coronavirusQuantosMembrosPossuemAtividadeProdutiva = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusQuantosMembrosPossuemAtividadeProdutiva');
  const coronavirusQuantidadeMembrosFamilia = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusQuantidadeMembrosFamilia');
  const coronavirusTrabalhoRegistrado = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusTrabalhoRegistrado');
  const cartaoSus = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CartaoSUS');
  const nomeSocial = listaCampos.find(({ NomeCampo }) => NomeCampo === 'NomeSocial');
  const resideForaDaCidade = listaCampos.find(({ NomeCampo }) => NomeCampo === 'ResideForaDaCidade');

  const validate = () => {
    // Juiz de Fora
    if (juizDeFora && values.Estudante === 'S') {
      if (!values.NomeInstituicao) {
        alert.error('Verifique o campo instituição de ensino.', { timeout: 5000 });
        return false;
      }
      if (!values.RedeEnsino) {
        alert.error('Verifique o campo rede de ensino.', { timeout: 5000 });
        return false;
      }
      if (!values.NivelEnsino) {
        alert.error('Verifique o campo nível de ensino.', { timeout: 5000 });
        return false;
      }
      if (!values.Periodo) {
        alert.error('Verifique o campo período de estudo.', { timeout: 5000 });
        return false;
      }
      // if (!values.DataInicio) {
      //   alert.error('Verifique o campo data início período letivo.', { timeout: 5000 });
      //   return false;
      // }
      // if (!values.DataTermino) {
      //   alert.error('Verifique o campo data término período letivo.', { timeout: 5000 });
      //   return false;
      // }
      if (!values.DiasLetivos) {
        alert.error('Verifique o campo dias de frequência letiva.', { timeout: 5000 });
        return false;
      }
      if (values.MaiorIdade === 'N' && !values.NomeResponsavel) {
        alert.error('Verifique o campo Nome do Responsável.', { timeout: 5000 });
        return false;
      }
      if (values.MaiorIdade === 'N' && !values.CPFResponsavel) {
        alert.error('Verifique o campo CPF do Responsável.', { timeout: 5000 });
        return false;
      }
      if (checkCreditosDiarios && !values.Justificativa) {
        alert.error('É necessário justificar a necessidade da disponibilização de 04 (quatro) créditos diários.', { timeout: 5000 });
        return false;
      }
      if (checkCreditosDiarios && !values.Linhas) {
        alert.error('É necessário informar as linhas de ônibus que serão utilizadas através da disponibilização de 04 (quatro) créditos diários.', { timeout: 5000 });
        return false;
      }

      // Tornando obrigatório campos padrão do cadastro de solicitante
      if (!values.CEP) {
        alert.error('Verifique o campo CEP.', { timeout: 5000 });
        return false;
      }
      if (!values.Endereco) {
        alert.error('Verifique o campo endereço.', { timeout: 5000 });
        return false;
      }
      if (!values.Numero) {
        alert.error('Verifique o campo número.', { timeout: 5000 });
        return false;
      }
      if (!values.DataNascimento) {
        alert.error('Verifique o campo data de nascimento.', { timeout: 5000 });
        return false;
      }
    }
    if (!values.Solicitante) {
      alert.error('Verifique o campo nome.', { timeout: 5000 });
      return false;
    }
    if (!values.Solicitante.match(/[a-zA-Z]* [a-zA-Z]*/)) {
      alert.error('Preencha nome e sobrenome completo.', { timeout: 5000 });
      return false;
    }
    if (nomeSocial.Visivel === 'S' && nomeSocial.Nulo === 'S' && !values.SolicitanteSocial) {
      alert.error('Verifique o campo nome social.', { timeout: 5000 });
      return false;
    }
    if (cepCampo.Visivel === 'S' && cepCampo.Nulo === 'S' && !values.CEP) {
      alert.error('Verifique o campo CEP.', { timeout: 5000 });
      return false;
    }
    if (!values.IdBairro) {
      if (!values.BairroTurista) {
        alert.error('Verifique o campo bairro.', { timeout: 5000 });
        return false;
      }
    }
    if (endereco.Visivel === 'S' && endereco.Nulo === 'S' && !values.Endereco) {
      alert.error('Verifique o campo endereço.', { timeout: 5000 });
      return false;
    }
    if (numero.Visivel === 'S' && numero.Nulo === 'S' && !values.Numero) {
      alert.error('Verifique o campo número.', { timeout: 5000 });
      return false;
    }
    if (complemento.Visivel === 'S' && complemento.Nulo === 'S' && !values.Complemento) {
      alert.error('Verifique o campo complemento.', { timeout: 5000 });
      return false;
    }
    if (telefone01.Visivel === 'S' && telefone01.Nulo === 'S' && !values.Telefone01) {
      alert.error('Verifique o campo telefone.', { timeout: 5000 });
      return false;
    }
    if (telefone02.Visivel === 'S' && telefone02.Nulo === 'S' && !values.Telefone02) {
      alert.error('Verifique o campo telefone secundário.', { timeout: 5000 });
      return false;
    }
    if (telefone03.Visivel === 'S' && telefone03.Nulo === 'S' && !values.Telefone03) {
      alert.error('Verifique o campo outro telefone.', { timeout: 5000 });
      return false;
    }
    if (coronavirusRendaMensal.Visivel === 'S' && coronavirusRendaMensal.Nulo === 'S' && !values.CoronavirusRendaMensal) {
      alert.error('Verifique o campo renda mensal.', { timeout: 5000 });
      return false;
    }
    if (coronavirusQuantosMembrosRecebemBolsaFamilia.Visivel === 'S' && coronavirusQuantosMembrosRecebemBolsaFamilia.Nulo === 'S' && !values.CoronavirusQuantosMembrosRecebemBolsaFamilia) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (coronavirusQuantosDiasSemTrabalhar.Visivel === 'S' && coronavirusQuantosDiasSemTrabalhar.Nulo === 'S' && !values.CoronavirusQuantosDiasSemTrabalhar) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (coronavirusQuantosMembrosPossuemAtividadeProdutiva.Visivel === 'S' && coronavirusQuantosMembrosPossuemAtividadeProdutiva.Nulo === 'S' && !values.CoronavirusQuantosMembrosPossuemAtividadeProdutiva) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (coronavirusQuantidadeMembrosFamilia.Visivel === 'S' && coronavirusQuantidadeMembrosFamilia.Nulo === 'S' && !values.CoronavirusQuantidadeMembrosFamilia) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (coronavirusTrabalhoRegistrado.Visivel === 'S' && coronavirusTrabalhoRegistrado.Nulo === 'S' && !values.CoronavirusTrabalhoRegistrado) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (dataNascimento.Visivel === 'S' && dataNascimento.Nulo === 'S' && !values.DataNascimento) {
      alert.error('Verifique o campo data de nascimento.', { timeout: 5000 });
      return false;
    }
    if (sexo.Visivel === 'S' && sexo.Nulo === 'S' && !values.Sexo) {
      alert.error('Verifique o campo sexo.', { timeout: 5000 });
      return false;
    }
    if (idGrauEscolaridade.Visivel === 'S' && idGrauEscolaridade.Nulo === 'S' && !values.IdGrauEscolaridade) {
      alert.error('Verifique o campo escolaridade.', { timeout: 5000 });
      return false;
    }
    if (rgCampo.Visivel === 'S' && rgCampo.Nulo === 'S' && !values.RG) {
      alert.error('Verifique o campo RG.', { timeout: 5000 });
      return false;
    }
    if (cpfcnpj.Visivel === 'S' && cpfcnpj.Nulo === 'S' && !values.CPFCNPJ) {
      alert.error('Verifique o campo CPF/CNPJ.', { timeout: 5000 });
      return false;
    }
    if (cartaoSus.Visivel === 'S' && cartaoSus.Nulo === 'S' && !values.cartaoSus) {
      alert.error('Verifique o campo cartão SUS.', { timeout: 5000 });
      return false;
    }
    if (emailCampo.Visivel === 'S' && emailCampo.Nulo === 'S' && !values.Email) {
      alert.error('Verifique o campo E-mail.', { timeout: 5000 });
      return false;
    }
    if (!values.Palavra) {
      alert.error('Verifique o campo senha.', { timeout: 5000 });
      return false;
    }
    if (values.PalavraConfirmacao !== values.Palavra) {
      alert.error('A confirmação de senha é diferente da senha inserida.', { timeout: 5000 });
      return false;
    }
    if (idComoFicouSabendo.Visivel === 'S' && idComoFicouSabendo.Nulo === 'S' && !values.IdComoFicouSabendo) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    return true;
  };

  const getIdBairro = (nomeBairro) => {
    if (!listaBairros) {
      return 'null';
    }

    const bairro = listaBairros.find(({ Campo }) => Campo === nomeBairro);
    if (!bairro) {
      return '';
    }
    return bairro.Id;
  };

  const buscarCep = async () => {
    const busca = values.CEP;

    if (busca.length === 8) {
      const resultado = await apiCep(busca);

      if (resultado.erro) {
        return alert.error('CEP não encontrado.', { timeout: 5000 });
      }

      return setValues({
        ...values,
        Endereco: resultado.logradouro,
        IdBairro: getIdBairro(resultado.bairro),
      });
    }

    return alert.error('Número de CEP inválido.', { timeout: 5000 });
  };

  const cadastrarSolicitante = async (event) => {
    event.preventDefault();
    setCarregando(true);

    if (!validate()) {
      setCarregando(false);
      return;
    }

    if (getTotem() !== 'true') {
      if (dadosCidade.configuracoes.TermoDeAceite && (values.TermosAplicativo === 'N' || values.TermosAplicativo === '')) {
        setCarregando(false);
        alert.error('Por favor, aceite os termos do aplicativo para continuar.', { timeout: 5000 });
        return;
      }
    }

    if (values.Palavra && values.Palavra.length < 6) {
      setCarregando(false);
      alert.error('A senha digitada deve ser maior do que 6 caracteres.', { timeout: 5000 });
      return;
    }

    const resposta = getTotem() === 'true' ? await postCadastrarSolicitanteTotem({
      ...values,
      OrigemCadastro: 'W',
      CoronavirusRendaMensal: values.CoronavirusRendaMensal ? values.CoronavirusRendaMensal.substring(3, 12) : '',
    }) : await postCadastrarSolicitante({
      ...values,
      OrigemCadastro: 'W',
      CoronavirusRendaMensal: values.CoronavirusRendaMensal ? values.CoronavirusRendaMensal.substring(3, 12) : '',
    });

    if (resposta.Error) {
      setCarregando(false);
      alert.error(resposta.Error, { timeout: 5000 });
      return;
    }

    setCarregando(false);

    // Só exibirá a mensagem de sucesso padrão pós cadastro, se não for Juiz de Fora OU se não for estudante.
    if (!juizDeFora || values.Estudante === 'N') {
      if (values.CPFCNPJ && values.Palavra && !values.Email) {
        alert.success(`Cadastro realizado. Comece a usar o aplicativo imediatamente, mas antes anote sua senha: ${values.Palavra}`, { timeout: 5000 });
      } else {
        alert.success('Cadastro realizado. Comece a usar o aplicativo imediatamente.', { timeout: 5000 });
      }
    }

    await dispatch(fetchLogin({
      username: values.Email ? values.Email : values.CPFCNPJ,
      password: values.Palavra,
    }));

    setValues(defaultValues);

    // Juiz de Fora
    // Se o usuário tiver clicado no botão do "Passe Livre Estudantil" (id: 10534), tanto pela tela inicial quanto pela tela de ouvidoria, ao finalizar o cadadastro será redirecionado diretamente para o formulário de ouvidoria.
    // a propriedade "origem === manifestacao" controla se a tela de cadastro foi aberta através do click em uma ouvidoria (ou se clicou no botão "passe livre estudantil" na tela inicial)
    // Caso a propriedade origem venha vazia, significa que o usuário clicou para se cadastrar através do menu lateral, e portanto não será redirecionado para o formulário da ouvidoria após cadastro.
    if (dadosModal && dadosModal.secretaria
      && dadosModal.secretaria.idSecretaria === '10534' && dadosModal.origem === 'manifestacao') {
      alert.show('Agora para finalizar o seu pedido do passe livre, nos envie os documentos solicitados.', { type: 'warning', title: 'Ja estamos quase lá!', timeout: 10000 });

      dispatch(definirSecretaria({
        idSecretaria: dadosModal.secretaria.idSecretaria,
        nomeSecretaria: dadosModal.secretaria.nomeSecretaria,
        corSecretaria: dadosModal.secretaria.corSecretaria,
      }));

      history.push('/ouvidoria');
    } else if (juizDeFora && values.Estudante === 'S') {
      // Nesse cenário, o usuário (estudante) clicou para se cadastrar através do menu lateral à esquerda (origem === ''). Portanto será redirecionado apenas para a tela inicial ao finalizar o cadastro.
      alert.show('Agora para finalizar o seu pedido do passe livre, clique em "Passe Livre Estudantil" e nos envie os documentos.', { type: 'warning', title: 'Ja estamos quase lá!', timeout: 10000 });
      history.push('/');
    } else {
      // Caso padrão de todas as cidades, ouvidorias/sic/zeladorias, onde ao finalizar o cadastro do usuário, você é redirecionado à tela inicial (ou à tela de ouvidoria se não houver tela inicial)
      history.push('/');
    }
  };

  const manipularTipoCampoSenha = () => {
    if (tipoCampoSenha === 'senha') {
      setTipoCampoSenha('text');
    } else {
      setTipoCampoSenha('senha');
    }
  };

  const manipularTipoCampoConfirmacaoSenha = () => {
    if (tipoCampoConfirmacaoSenha === 'senha') {
      setTipoCampoConfirmacaoSenha('text');
    } else {
      setTipoCampoConfirmacaoSenha('senha');
    }
  };

  return (
    <Container totem={getTotem() === 'true'}>
      <Titulo totem={getTotem() === 'true'}>Cadastrar - Solicitante</Titulo>

      <Interno>
        <Alerta style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {getTotem() === 'true' && (
            <strong style={{ fontSize: '1.3em' }}>* Os campos com asterisco são obrigatórios.</strong>
          )}
          {getTotem() !== 'true' && (
          <strong style={{ fontSize: '0.9em' }}>* Os campos com asterisco são obrigatórios.</strong>
          )}
        </Alerta>

        <Divisor style={{ marginBottom: 6, paddingBottom: 6 }} />

        {getTotem() === 'true' && (
        <form>
          <LinhaFormTotem>

            <FormControl
              idCampo="inputSolicitante"
              value={values.Solicitante && name(values.Solicitante)}
              label="Nome:"
              onChange={({ target }) => setVal('Solicitante', target.value)}
              tamanhoFlex={3}
              required
              type="inputTotem"
            />
            <FormControl
              idCampo="inputSolicitanteSocial"
              value={values.SolicitanteSocial && name(values.SolicitanteSocial)}
              label="Nome social:"
              onChange={({ target }) => setVal('SolicitanteSocial', target.value)}
              type="inputTotem"
            />
          </LinhaFormTotem>
          {/* <LinhaForm>
            <FormControl
              idCampo="selectTurista"
              value={values.Turista}
              label="Reside fora da cidade?"
              noBlank
              options={bool}
              tamanhoFlex={2}
              type="select"
              onChange={({ target }) => {
                setValues({
                  ...values,
                  IdBairro: '',
                  IdEstadoTurista: '',
                  IdCidadeTurista: '',
                  BairroTurista: '',
                  Turista: target.value,
                });
              }}
            />
            {values && values.Turista === 'S' && (
            <>
              <FormControl
                idCampo="selectEstadoTurista"
                value={values.IdEstadoTurista}
                label="Estado"
                options={listaEstadosTurismo}
                onChange={({ target }) => {
                  setVal('IdEstadoTurista', target.value);
                  fetchCidadesTurismo(target.value).then((data) => setListaCidadesTurismo(data));
                }}
                type="select"
                tamanhoFlex={2}
              />

              <FormControl
                idCampo="selectCidadeTurista"
                value={values.IdCidadeTurista}
                label="Cidade"
                options={listaCidadesTurismo}
                onChange={({ target }) => setVal('IdCidadeTurista', target.value)}
                type="select"
                tamanhoFlex={2}
              />
            </>
            )}
          </LinhaForm> */}
          <LinhaFormTotem>
            {cepCampo.Visivel === 'S' && (
              <FormControl
                idCampo="inputCep"
                value={values.CEP && cep(values.CEP)}
                label="CEP:"
                type="cepTotem"
                busca={endereco.Visivel === 'S'}
                onChange={({ target }) => setVal('CEP', replaceEspeciais(target.value))}
                maxLength={9}
                required={cepCampo.Nulo === 'S'}
                onClick={buscarCep}
              />
            )}

            {(values && values.Turista === 'N')
              ? (
                // <FormControl
                //   idCampo="inputSelectBairro"
                //   value={values.IdBairro}
                //   type="select"
                //   label="Bairro"
                //   options={listaBairros}
                //   onChange={({ target }) => setVal('IdBairro', target.value)}
                //   required
                // />
                <FormControl
                  idCampo="selectBairro"
                  value={(bairroTotem && bairroTotem.bairro && bairroTotem.bairro !== '' && bairroTotem.bairro) || values.IdBairro}
                  type="selectBairrosTotem"
                  label="Bairro:"
                  onChange={({ target }) => setVal('IdBairro', target.value)}
                  required
                  placeholder="Selecione"
                  onClick={(e) => { dispatch(abrirModalBairro({ bairros: listaBairros })); e.target.blur(); }}
                />
              )
              : (
                <FormControl
                  idCampo="inputBairroTurista"
                  value={values.BairroTurista}
                  label="Bairro:"
                  onChange={({ target }) => setVal('BairroTurista', target.value)}
                  required
                />
              )}
          </LinhaFormTotem>
          <LinhaForm>
            {endereco.Visivel === 'S' && (
              <FormControl
                idCampo="inputEndereco"
                value={values.Endereco}
                label="Endereço:"
                onChange={({ target }) => setVal('Endereco', target.value)}
                required={endereco.Nulo === 'S'}
                type="inputTotem"
                tamanhoFlex={3}
              />
            )}
          </LinhaForm>
          <LinhaFormTotem>
            {numero.Visivel === 'S' && (
              <FormControl
                idCampo="inputNumero"
                value={values.Numero && number(values.Numero)}
                label="Número:"
                onChange={({ target }) => setVal('Numero', target.value)}
                maxLength={5}
                required={numero.Nulo === 'S'}
                type="inputTotem"
                tamanhoFlex={1.5}
              />
            )}

            {complemento.Visivel === 'S' && (
              <FormControl
                idCampo="inputComplemento"
                value={values.Complemento}
                label="Complemento:"
                onChange={({ target }) => setVal('Complemento', target.value)}
                required={complemento.Nulo === 'S'}
                type="inputTotem"
                tamanhoFlex={1.5}
              />
            )}

            {telefone01.Visivel === 'S' && (
              <FormControl
                idCampo="inputTelefone01"
                value={values.Telefone01 && tel(values.Telefone01)}
                label="Telefone principal:"
                onChange={({ target }) => setVal('Telefone01', replaceEspeciais(target.value))}
                required={telefone01.Nulo === 'S'}
                type="inputTotem"
              />
            )}

            {telefone02.Visivel === 'S' && (
              <FormControl
                idCampo="inputTelefone02"
                value={values.Telefone02 && tel(values.Telefone02)}
                label="Telefone secundário:"
                onChange={({ target }) => setVal('Telefone02', replaceEspeciais(target.value))}
                required={telefone02.Nulo === 'S'}
                type="inputTotem"
              />
            )}

            {telefone03.Visivel === 'S' && (
              <FormControl
                idCampo="inputTelefone03"
                value={values.Telefone03 && tel(values.Telefone03)}
                label="Outro telefone / recado:"
                onChange={({ target }) => setVal('Telefone03', replaceEspeciais(target.value))}
                required={telefone03.Nulo === 'S'}
                type="inputTotem"
              />
            )}

            {dataNascimento.Visivel === 'S' && (
              <FormControl
                idCampo="inputDataNascimento"
                value={values.DataNascimento && date(values.DataNascimento)}
                label="Data de nascimento:"
                onChange={({ target }) => setVal('DataNascimento', target.value)}
                required={dataNascimento.Nulo === 'S'}
                type="inputTotem"
              />
            )}

            {sexo.Visivel === 'S' && (
            // <FormControl
            //   idCampo="selectSexo"
            //   value={values.Sexo}
            //   type="select"
            //   label="Gênero"
            //   options={boolSexo}
            //   onChange={({ target }) => setVal('Sexo', target.value)}
            //   required={sexo.Nulo === 'S'}
            // />

            <FormControl
              idCampo="selectSexo"
              value={(sexoTotem && sexoTotem.sexo && sexoTotem.sexo !== '' && sexoTotem.sexo) || values.Sexo}
              type="selectBairrosTotem"
              label="Gênero:"
              onChange={({ target }) => setVal('Sexo', target.value)}
              required
              placeholder="Selecione"
              onClick={(e) => { dispatch(abrirModalSexo({ sexo: boolSexo })); e.target.blur(); }}
            />
            )}

            {idGrauEscolaridade.Visivel === 'S' && (
            // <FormControl
            //   idCampo="selectGrauEscolaridade"
            //   value={values.IdGrauEscolaridade}
            //   type="select"
            //   label="Escolaridade"
            //   options={listaEscolaridades}
            //   onChange={({ target }) => setVal('IdGrauEscolaridade', target.value)}
            //   required={idGrauEscolaridade.Nulo === 'S'}
            // />

              <FormControl
                idCampo="selectGrauEscolaridade"
                value={(escolaridadeTotem && escolaridadeTotem.escolaridade && escolaridadeTotem.escolaridade !== '' && escolaridadeTotem.escolaridade) || values.IdGrauEscolaridade}
                type="selectBairrosTotem"
                label="Escolaridade:"
                onChange={({ target }) => setVal('IdGrauEscolaridade', target.value)}
                required
                placeholder="Selecione"
                onClick={(e) => { dispatch(abrirModalEscolaridade({ escolaridade: listaEscolaridades })); e.target.blur(); }}
              />
            )}

            {rgCampo.Visivel === 'S' && (
              <FormControl
                idCampo="inputRg"
                value={values.RG && rg(values.RG)}
                label="RG:"
                onChange={({ target }) => setVal('RG', replaceEspeciais(target.value))}
                required={rgCampo.Nulo === 'S'}
                type="inputTotem"
              />
            )}

            {cpfcnpj.Visivel === 'S' && (
              <>
                {values.CPFCNPJ && isCNPJ(values.CPFCNPJ)
                  ? (
                    <FormControl
                      idCampo="inputCpfCnpj"
                      value={values.CPFCNPJ && cnpj(values.CPFCNPJ)}
                      label="CPF/CNPJ:"
                      onChange={({ target }) => setVal('CPFCNPJ', target.value)}
                      required={cpfcnpj.Nulo === 'S'}
                      type="inputTotem"
                    />
                  )
                  : (
                    <FormControl
                      idCampo="inputCpfCnpj"
                      value={values.CPFCNPJ && cpf(values.CPFCNPJ)}
                      label="CPF/CNPJ:"
                      onChange={({ target }) => setVal('CPFCNPJ', target.value)}
                      required={cpfcnpj.Nulo === 'S'}
                      type="inputTotem"
                    />
                  )}
              </>
            )}

            {cartaoSus.Visivel === 'S' && (
              <FormControl
                idCampo="inputSus"
                value={values.cartaoSus && sus(values.cartaoSus)}
                label="Cartão SUS:"
                onChange={({ target }) => setVal('cartaoSus', replaceEspeciais(target.value))}
                required={cartaoSus.Nulo === 'S'}
                type="inputTotem"
              />
            )}

            {coronavirusQuantidadeMembrosFamilia.Visivel === 'S' && (
              <FormControl
                idCampo="selectCoronavirusQuantidadeMembrosFamilia"
                value={values.CoronavirusQuantidadeMembrosFamilia}
                type="select"
                label="Quantidade de membros da família?"
                options={coronaNumeros}
                onChange={({ target }) => setVal('CoronavirusQuantidadeMembrosFamilia', target.value)}
                required={coronavirusQuantidadeMembrosFamilia.Nulo === 'S'}
              />
            )}

            {coronavirusQuantosMembrosPossuemAtividadeProdutiva.Visivel === 'S' && (
              <FormControl
                idCampo="selectCoronavirusQuantosMembrosPossuemAtividadeProdutiva"
                value={values.CoronavirusQuantosMembrosPossuemAtividadeProdutiva}
                type="select"
                label="Quantos membros possuem atividade produtiva?"
                options={coronaNumeros}
                onChange={({ target }) => setVal('CoronavirusQuantosMembrosPossuemAtividadeProdutiva', target.value)}
                required={coronavirusQuantosMembrosPossuemAtividadeProdutiva.Nulo === 'S'}
              />
            )}

            {coronavirusQuantosMembrosRecebemBolsaFamilia.Visivel === 'S' && (
              <FormControl
                idCampo="selectCoronavirusQuantosMembrosRecebemBolsaFamilia"
                value={values.CoronavirusQuantosMembrosRecebemBolsaFamilia}
                type="select"
                label="Membros que recebem bolsa família ou BPC (benefício de prestação continuada)?"
                options={coronaNumeros}
                onChange={({ target }) => setVal('CoronavirusQuantosMembrosRecebemBolsaFamilia', target.value)}
                required={coronavirusQuantosMembrosRecebemBolsaFamilia.Nulo === 'S'}
              />
            )}

            {coronavirusTrabalhoRegistrado.Visivel === 'S' && (
              <FormControl
                idCampo="selectCoronavirusTrabalhoRegistrado"
                value={values.CoronavirusTrabalhoRegistrado}
                label="Trabalho registrado?"
                options={bool}
                onChange={({ target }) => setVal('CoronavirusTrabalhoRegistrado', target.value)}
                type="select"
                required={coronavirusTrabalhoRegistrado.Nulo === 'S'}
              />
            )}

            {coronavirusQuantosDiasSemTrabalhar.Visivel === 'S' && (
              <FormControl
                idCampo="selectCoronavirusQuantosDiasSemTrabalhar"
                value={values.CoronavirusQuantosDiasSemTrabalhar}
                label="Quantos dias sem trabalhar?"
                options={coronaNumeros}
                onChange={({ target }) => setVal('CoronavirusQuantosDiasSemTrabalhar', target.value)}
                type="select"
                required={coronavirusQuantosDiasSemTrabalhar.Nulo === 'S'}
              />
            )}

            {coronavirusRendaMensal.Visivel === 'S' && (
              <FormControl
                idCampo="inputCoronavirusRendaMensal"
                label="Renda mensal:"
                value={values.CoronavirusRendaMensal}
                onChange={(val) => setVal('CoronavirusRendaMensal', val)}
                maxLength={12}
                type="money"
                required={coronavirusRendaMensal.Nulo === 'S'}
              />
            )}

            {emailCampo.Visivel === 'S' && (
            <FormControl
              idCampo="inputEmail"
              value={values.Email && email(values.Email)}
              label="E-mail:"
              onChange={({ target }) => setVal('Email', target.value)}
              required={emailCampo.Nulo === 'S'}
              type="inputTotem"
            />
            )}
          </LinhaFormTotem>

          <LinhaForm>
            <FormControl
              idCampo="inputPalavra"
              value={values.Palavra}
              label="Senha:"
              onChange={({ target }) => setVal('Palavra', target.value)}
              type="senhaTotemCadastro"
              required
            />

            <FormControl
              idCampo="inputPalavraConfirmacao"
              value={values.PalavraConfirmacao}
              label="Confirme a senha:"
              onChange={({ target }) => setVal('PalavraConfirmacao', target.value)}
              type="senhaTotemCadastro"
              required
            />
          </LinhaForm>

          {idComoFicouSabendo && idComoFicouSabendo.Visivel === 'S' && (
            <FormControl
              idCampo="selectComoFicouSabendo"
              value={(comoSoubeTotem && comoSoubeTotem.comoSoube && comoSoubeTotem.comoSoube !== '' && comoSoubeTotem.comoSoube) || values.IdComoFicouSabendo}
              type="selectBairrosTotem"
              label="Como soube deste aplicativo?"
              onChange={({ target }) => setVal('IdComoFicouSabendo', target.value)}
              required={idComoFicouSabendo.Nulo === 'S'}
              placeholder="Selecione"
              onClick={(e) => { dispatch(abrirModalComoSoube({ comoSoube: listaFicouSabendo })); e.target.blur(); }}
            />
          )}

          {/* {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.TermoDeAceite && (
          <FormControl
            type="termosTotem"
            labelCheck="Li e aceito os termos de uso do aplicativo."
            nameCheck="Aceite"
            required
            idCheck="checkAceite"
            valueCheck={values.TermosAplicativo}
            changeCheck={() => {
              setValues({
                ...values,
                TermosAplicativo: values.TermosAplicativo === 'S' ? 'N' : 'S',
              });
            }}
          />
          ) } */}

          {/* <LinhaForm style={{ marginTop: 20 }}>
            <FormControl
              type="checkCadastroTotem"
              labelCheck="Desejo receber notificações e informações."
              nameCheck="Notificacoes"
              idCheck="checkNotificacoes"
              valueCheck={values.ReceberNews}
              changeCheck={() => {
                setValues({
                  ...values,
                  ReceberNews: values.ReceberNews === 'S' ? 'N' : 'S',
                });
              }}
              checked={values.ReceberNews === 'S'}
            />
          </LinhaForm>

          <LinhaForm style={{ marginTop: 5 }}>
            <FormControl
              type="checkCadastroTotem"
              labelCheck="Desejo fazer parte do conselho de usuários."
              nameCheck="ConselhoUsuarios"
              idCheck="checkConselho"
              valueCheck={values.ConselhoOuvidoria}
              changeCheck={() => {
                setValues({
                  ...values,
                  ConselhoOuvidoria: values.ConselhoOuvidoria === 'S' ? 'N' : 'S',
                });
              }}
              checked={values.ConselhoOuvidoria === 'S'}
            />
          </LinhaForm> */}

          <FormFooter>
            {carregando !== true
              ? (
                <Botao
                  style={{
                    width: '100%',
                    fontSize: '1.43em',
                    padding: 20,
                    marginTop: 30,
                  }}
                  label="Enviar"
                  type="submitTotem"
                  onClick={cadastrarSolicitante}
                />
              )
              : (
                <Carregar />
              )}
          </FormFooter>

        </form>
        )}

        {getTotem() !== 'true' && (
        <form>
          {juizDeFora && (
            <>
              <FormControl
                idCampo="selectEstudante"
                value={values.Estudante}
                label="É estudante?"
                options={bool}
                onChange={({ target }) => setValues({ ...values, Estudante: target.value, CPFCNPJ: '' })}
                type="select"
              />

              {values.Estudante === 'S' && (
                <>
                  <LinhaForm>
                    <FormControl
                      idCampo="selectNomeInstituicao"
                      value={values.NomeInstituicao}
                      label="Nome da Instituição de Ensino:"
                      options={listaInstituicaoEnsino}
                      onChange={({ target }) => setVal('NomeInstituicao', target.value)}
                      type="select"
                      utilizarTituloComoValor
                      required
                    />

                    <FormControl
                      idCampo="selectRedeEnsino"
                      value={values.RedeEnsino}
                      label="Rede de Ensino:"
                      options={boolRedeEnsino}
                      onChange={({ target }) => setVal('RedeEnsino', target.value)}
                      type="select"
                      required
                    />
                  </LinhaForm>

                  {/* <LinhaForm>
                    <FormControl
                      idCampo="inputDataInicio"
                      value={values.DataInicio}
                      label="Data de Início do Período Letivo:"
                      onChange={({ target }) => setVal('DataInicio', target.value)}
                      type="date"
                      required
                    />
                    <FormControl
                      idCampo="inputDataTermino"
                      value={values.DataTermino}
                      label="Data de Término do Período Letivo:"
                      onChange={({ target }) => setVal('DataTermino', target.value)}
                      type="date"
                      required
                    />
                  </LinhaForm> */}

                  <LinhaForm>
                    <FormControl
                      idCampo="selectNivelEnsino"
                      value={values.NivelEnsino}
                      label="Nível de Ensino:"
                      options={boolNivelEnsino}
                      onChange={({ target }) => setVal('NivelEnsino', target.value)}
                      type="select"
                      required
                    />
                    <FormControl
                      idCampo="selectPeriodo"
                      value={values.Periodo}
                      label="Período de Estudo:"
                      options={boolPeriodoEstudo}
                      onChange={({ target }) => setVal('Periodo', target.value)}
                      type="select"
                      required
                    />
                  </LinhaForm>

                  <LinhaForm>
                    <FormControl
                      idCampo="checkboxDiasLetivos"
                      value={values.DiasLetivos}
                      label="Dias de Frequência Letiva:"
                      onChange={(diasSelecionadosStr) => setVal('DiasLetivos', diasSelecionadosStr)}
                      type="list-checkbox"
                      options={checkDiasSemana}
                      required
                    />
                  </LinhaForm>

                  <Divisor size="ultraPequeno" />

                  <LinhaForm>
                    <FormControl
                      idCampo="selectMaiorIdade"
                      value={values.MaiorIdade}
                      label="É maior de idade? (acima de 18 anos)"
                      options={bool}
                      onChange={({ target }) => setVal('MaiorIdade', target.value)}
                      type="select"
                    />

                    <FormControl
                      idCampo="inputNomeResponsavel"
                      value={values.NomeResponsavel && name(values.NomeResponsavel)}
                      label="Nome do responsável:"
                      onChange={({ target }) => setVal('NomeResponsavel', target.value)}
                      required={values.MaiorIdade === 'N'}
                    />

                    <FormControl
                      idCampo="inputCPFResponsavel"
                      value={values.CPFResponsavel && cpf(values.CPFResponsavel)}
                      label="CPF do responsável:"
                      onChange={({ target }) => setVal('CPFResponsavel', target.value)}
                      required={values.MaiorIdade === 'N'}
                    />
                  </LinhaForm>

                  <Divisor size="ultraPequeno" />

                  <LinhaForm>
                    <div>
                      <div style={{ marginBottom: 8 }}>Serão disponibilizados 02 (dois) créditos diários. Para mais créditos, marcar a caixa abaixo.</div>

                      <FormControl
                        type="check2"
                        labelCheck="Solicito a disponibilização de 04 (quatro) créditos diários para o deslocamento entre a residência e a Instituição de Ensino, conforme justificativa abaixo:"
                        nameCheck="CreditosDiarios"
                        idCheck="checkCreditosDiarios"
                        changeCheck={() => {
                          setCheckCreditosDiarios(!checkCreditosDiarios);
                          setValues({
                            ...values,
                            Justificativa: '',
                            Linhas: '',
                          });
                        }}
                        checked={checkCreditosDiarios}
                      />
                    </div>
                  </LinhaForm>

                  <LinhaForm>
                    <FormControl
                      idCampo="inputJustificativa"
                      value={values.Justificativa}
                      onChange={({ target }) => setVal('Justificativa', target.value)}
                      disabled={!checkCreditosDiarios}
                    />
                  </LinhaForm>

                  <LinhaForm>
                    <FormControl
                      idCampo="inputLinhas"
                      value={values.Linhas}
                      label="Indique as linhas de ônibus:"
                      onChange={({ target }) => setVal('Linhas', target.value)}
                      required={checkCreditosDiarios}
                      disabled={!checkCreditosDiarios}
                    />
                  </LinhaForm>

                  <Divisor size="pequeno" />

                  <hr />

                  <Divisor size="ultraPequeno" />
                </>
              )}
            </>
          )}

          <LinhaForm>
            <FormControl
              idCampo="inputSolicitante"
              value={values.Solicitante && name(values.Solicitante)}
              label={juizDeFora && values.Estudante === 'S' ? 'Nome do estudante:' : 'Nome:'}
              onChange={({ target }) => setVal('Solicitante', target.value)}
              tamanhoFlex={3}
              required
            />

            {nomeSocial && nomeSocial.Visivel === 'S' && (
              <FormControl
                idCampo="inputSolicitanteSocial"
                value={values.SolicitanteSocial && name(values.SolicitanteSocial)}
                label={juizDeFora && values.Estudante === 'S' ? 'Nome social do estudante:' : 'Nome social:'}
                onChange={({ target }) => setVal('SolicitanteSocial', target.value)}
                required={nomeSocial.Nulo === 'S'}
                tamanhoFlex={3}
              />
            )}
          </LinhaForm>

          <LinhaForm>
            {resideForaDaCidade && resideForaDaCidade.Visivel === 'S' && (
              <FormControl
                idCampo="selectTurista"
                value={values.Turista}
                label="Reside fora da cidade?"
                noBlank
                options={bool}
                type="select"
                onChange={({ target }) => {
                  setValues({
                    ...values,
                    IdBairro: '',
                    IdEstadoTurista: '',
                    IdCidadeTurista: '',
                    BairroTurista: '',
                    Turista: target.value,
                  });
                }}
              />
            )}

            {(values && values.Turista === 'S') && (resideForaDaCidade && resideForaDaCidade.Visivel === 'S') && (
            <>
              <FormControl
                idCampo="selectEstadoTurista"
                value={values.IdEstadoTurista}
                label="Estado:"
                options={listaEstadosTurismo}
                onChange={({ target }) => {
                  setVal('IdEstadoTurista', target.value);
                  fetchCidadesTurismo(target.value).then((data) => setListaCidadesTurismo(data));
                }}
                required={(juizDeFora && values.Estudante === 'S')}
                type="select"
              />

              <FormControl
                idCampo="selectCidadeTurista"
                value={values.IdCidadeTurista}
                label="Cidade:"
                options={listaCidadesTurismo}
                onChange={({ target }) => setVal('IdCidadeTurista', target.value)}
                required={(juizDeFora && values.Estudante === 'S')}
                type="select"
              />
            </>
            )}
          </LinhaForm>

          <LinhaForm>
            {cepCampo.Visivel === 'S' && (
            <FormControl
              idCampo="inputCep"
              value={values.CEP && cep(values.CEP)}
              label="CEP:"
              type="cep"
              busca={endereco.Visivel === 'S'}
              onChange={({ target }) => setVal('CEP', replaceEspeciais(target.value))}
              maxLength={9}
              required={(juizDeFora && values.Estudante === 'S') || cepCampo.Nulo === 'S'}
              onClick={buscarCep}
            />
            )}

            {(values && values.Turista === 'N')
              ? (
                <FormControl
                  idCampo="inputSelectBairro"
                  value={values.IdBairro}
                  type="select"
                  label="Bairro:"
                  options={listaBairros}
                  onChange={({ target }) => setVal('IdBairro', target.value)}
                  required
                />
              )
              : (
                <FormControl
                  idCampo="inputBairroTurista"
                  value={values.BairroTurista}
                  label="Bairro:"
                  onChange={({ target }) => setVal('BairroTurista', target.value)}
                  required
                />
              )}

          </LinhaForm>

          <LinhaForm>
            {endereco.Visivel === 'S' && (
            <FormControl
              idCampo="inputEndereco"
              value={values.Endereco}
              label="Endereço:"
              onChange={({ target }) => setVal('Endereco', target.value)}
              required={(juizDeFora && values.Estudante === 'S') || endereco.Nulo === 'S'}
            />
            )}

            {numero.Visivel === 'S' && (
            <FormControl
              idCampo="inputNumero"
              value={values.Numero && number(values.Numero)}
              label="Número:"
              onChange={({ target }) => setVal('Numero', target.value)}
              maxLength={5}
              required={(juizDeFora && values.Estudante === 'S') || numero.Nulo === 'S'}
            />
            )}

            {complemento.Visivel === 'S' && (
            <FormControl
              idCampo="inputComplemento"
              value={values.Complemento}
              label="Complemento:"
              onChange={({ target }) => setVal('Complemento', target.value)}
              required={complemento.Nulo === 'S'}
            />
            )}

          </LinhaForm>

          <LinhaForm>
            {telefone01.Visivel === 'S' && (
            <FormControl
              idCampo="inputTelefone01"
              value={values.Telefone01 && tel(values.Telefone01)}
              label="Telefone principal:"
              onChange={({ target }) => setVal('Telefone01', replaceEspeciais(target.value))}
              required={telefone01.Nulo === 'S'}
            />
            )}

            {telefone02.Visivel === 'S' && (
            <FormControl
              idCampo="inputTelefone02"
              value={values.Telefone02 && tel(values.Telefone02)}
              label="Telefone secundário:"
              onChange={({ target }) => setVal('Telefone02', replaceEspeciais(target.value))}
              required={telefone02.Nulo === 'S'}
            />
            )}

            {telefone03.Visivel === 'S' && (
            <FormControl
              idCampo="inputTelefone03"
              value={values.Telefone03 && tel(values.Telefone03)}
              label="Outro telefone / recado:"
              onChange={({ target }) => setVal('Telefone03', replaceEspeciais(target.value))}
              required={telefone03.Nulo === 'S'}
            />
            )}
          </LinhaForm>

          <LinhaForm>
            {dataNascimento.Visivel === 'S' && (
            <FormControl
              idCampo="inputDataNascimento"
              value={values.DataNascimento && date(values.DataNascimento)}
              label={juizDeFora && values.Estudante === 'S' ? 'Data de nascimento do estudante:' : 'Data de nascimento:'}
              onChange={({ target }) => setVal('DataNascimento', target.value)}
              tamanhoFlex={1.5}
              required={(juizDeFora && values.Estudante === 'S') || dataNascimento.Nulo === 'S'}
            />
            )}

            {sexo.Visivel === 'S' && (
            <FormControl
              idCampo="selectSexo"
              value={values.Sexo}
              type="select"
              label={juizDeFora && values.Estudante === 'S' ? 'Gênero do estudante:' : 'Gênero:'}
              options={boolSexo}
              onChange={({ target }) => setVal('Sexo', target.value)}
              required={sexo.Nulo === 'S'}
            />
            )}

            {idGrauEscolaridade.Visivel === 'S' && (
            <FormControl
              idCampo="selectGrauEscolaridade"
              value={values.IdGrauEscolaridade}
              type="select"
              label="Escolaridade:"
              options={listaEscolaridades}
              onChange={({ target }) => setVal('IdGrauEscolaridade', target.value)}
              tamanhoFlex={3}
              required={idGrauEscolaridade.Nulo === 'S'}
            />
            )}

          </LinhaForm>

          <LinhaForm>
            {rgCampo.Visivel === 'S' && (
            <FormControl
              idCampo="inputRg"
              value={values.RG && rg(values.RG)}
              label={juizDeFora && values.Estudante === 'S' ? 'RG do estudante:' : 'RG:'}
              onChange={({ target }) => setVal('RG', replaceEspeciais(target.value))}
              required={rgCampo.Nulo === 'S'}
            />
            )}

            {cpfcnpj.Visivel === 'S' && (
            <>
              {juizDeFora && values.Estudante === 'S' ? (
                <FormControl
                  idCampo="inputCpfCnpj"
                  value={values.CPFCNPJ && cpf(values.CPFCNPJ)}
                  label="CPF do estudante:"
                  onChange={({ target }) => setVal('CPFCNPJ', target.value)}
                  required={cpfcnpj.Nulo === 'S'}
                />
              ) : (
                <FormControl
                  idCampo="inputCpfCnpj"
                  value={values.CPFCNPJ && isCNPJ(values.CPFCNPJ) ? (values.CPFCNPJ && cnpj(values.CPFCNPJ)) : (values.CPFCNPJ && cpf(values.CPFCNPJ))}
                  label="CPF/CNPJ:"
                  onChange={({ target }) => setVal('CPFCNPJ', target.value)}
                  required={cpfcnpj.Nulo === 'S'}
                />
              )}
            </>
            )}

            {cartaoSus.Visivel === 'S' && (
            <FormControl
              idCampo="inputSus"
              value={values.cartaoSus && sus(values.cartaoSus)}
              label={juizDeFora && values.Estudante === 'S' ? 'Cartão SUS do estudante:' : 'Cartão SUS:'}
              onChange={({ target }) => setVal('cartaoSus', replaceEspeciais(target.value))}
              required={cartaoSus.Nulo === 'S'}
            />
            )}

          </LinhaForm>

          <LinhaForm>
            {coronavirusQuantidadeMembrosFamilia.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusQuantidadeMembrosFamilia"
              value={values.CoronavirusQuantidadeMembrosFamilia}
              type="select"
              label="Quantidade de membros da família?"
              options={coronaNumeros}
              onChange={({ target }) => setVal('CoronavirusQuantidadeMembrosFamilia', target.value)}
              required={coronavirusQuantidadeMembrosFamilia.Nulo === 'S'}
            />
            )}

            {coronavirusQuantosMembrosPossuemAtividadeProdutiva.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusQuantosMembrosPossuemAtividadeProdutiva"
              value={values.CoronavirusQuantosMembrosPossuemAtividadeProdutiva}
              type="select"
              label="Quantos membros possuem atividade produtiva?"
              options={coronaNumeros}
              onChange={({ target }) => setVal('CoronavirusQuantosMembrosPossuemAtividadeProdutiva', target.value)}
              required={coronavirusQuantosMembrosPossuemAtividadeProdutiva.Nulo === 'S'}
            />
            )}

            {coronavirusQuantosMembrosRecebemBolsaFamilia.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusQuantosMembrosRecebemBolsaFamilia"
              value={values.CoronavirusQuantosMembrosRecebemBolsaFamilia}
              type="select"
              label="Membros que recebem bolsa família ou BPC (benefício de prestação continuada)?"
              options={coronaNumeros}
              onChange={({ target }) => setVal('CoronavirusQuantosMembrosRecebemBolsaFamilia', target.value)}
              required={coronavirusQuantosMembrosRecebemBolsaFamilia.Nulo === 'S'}
            />
            )}

          </LinhaForm>

          <LinhaForm>
            {coronavirusTrabalhoRegistrado.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusTrabalhoRegistrado"
              value={values.CoronavirusTrabalhoRegistrado}
              label="Trabalho registrado?"
              options={bool}
              onChange={({ target }) => setVal('CoronavirusTrabalhoRegistrado', target.value)}
              type="select"
              required={coronavirusTrabalhoRegistrado.Nulo === 'S'}
            />
            )}

            {coronavirusQuantosDiasSemTrabalhar.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusQuantosDiasSemTrabalhar"
              value={values.CoronavirusQuantosDiasSemTrabalhar}
              label="Quantos dias sem trabalhar?"
              options={coronaNumeros}
              onChange={({ target }) => setVal('CoronavirusQuantosDiasSemTrabalhar', target.value)}
              type="select"
              required={coronavirusQuantosDiasSemTrabalhar.Nulo === 'S'}
            />
            )}

            {coronavirusRendaMensal.Visivel === 'S' && (
            <FormControl
              idCampo="inputCoronavirusRendaMensal"
              label="Renda mensal:"
              value={values.CoronavirusRendaMensal}
              onChange={(val) => setVal('CoronavirusRendaMensal', val)}
              maxLength={12}
              type="money"
              required={coronavirusRendaMensal.Nulo === 'S'}
            />
            )}
          </LinhaForm>

          <LinhaForm>
            {emailCampo.Visivel === 'S' && (
            <FormControl
              idCampo="inputEmail"
              value={values.Email && email(values.Email)}
              label="E-mail:"
              onChange={({ target }) => setVal('Email', target.value)}
              required={emailCampo.Nulo === 'S'}
            />
            )}

            <div style={{ flex: 1, position: 'relative' }}>
              <FormControl
                idCampo="inputPalavra"
                value={values.Palavra}
                label="Senha:"
                onChange={({ target }) => setVal('Palavra', target.value)}
                type={tipoCampoSenha}
                required
              />

              <FormControl
                value={tipoCampoSenha}
                type="exibirSenha"
                altura="15"
                onClick={() => { manipularTipoCampoSenha(); }}
              />
            </div>

            <div style={{ flex: 1, position: 'relative' }}>
              <FormControl
                idCampo="inputPalavraConfirmacao"
                value={values.PalavraConfirmacao}
                label="Confirme a senha:"
                onChange={({ target }) => setVal('PalavraConfirmacao', target.value)}
                type={tipoCampoConfirmacaoSenha}
                required
              />

              <FormControl
                value={tipoCampoConfirmacaoSenha}
                type="exibirSenha"
                altura="15"
                onClick={() => { manipularTipoCampoConfirmacaoSenha(); }}
              />
            </div>
          </LinhaForm>

          {idComoFicouSabendo && idComoFicouSabendo.Visivel === 'S' && (
          <FormControl
            idCampo="selectComoFicouSabendo"
            value={values.IdComoFicouSabendo}
            label="Como soube deste aplicativo?"
            options={listaFicouSabendo}
            onChange={({ target }) => setVal('IdComoFicouSabendo', target.value)}
            type="select"
            required={idComoFicouSabendo.Nulo === 'S'}
          />
          )}

          {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.TermoDeAceite && (
          <FormControl
            type="termos"
            labelCheck="Li e aceito os termos de uso do aplicativo."
            nameCheck="Aceite"
            required
            idCheck="checkAceite"
            valueCheck={values.TermosAplicativo}
            changeCheck={() => {
              setValues({
                ...values,
                TermosAplicativo: values.TermosAplicativo === 'S' ? 'N' : 'S',
              });
            }}
          />
          ) }

          <LinhaForm style={{ marginTop: 20 }}>
            <FormControl
              type="check2"
              labelCheck="Desejo receber notificações e informações."
              nameCheck="Notificacoes"
              idCheck="checkNotificacoes"
              valueCheck={values.ReceberNews}
              changeCheck={() => {
                setValues({
                  ...values,
                  ReceberNews: values.ReceberNews === 'S' ? 'N' : 'S',
                });
              }}
              checked={values.ReceberNews === 'S'}
            />
          </LinhaForm>

          {dadosCidade && dadosCidade.data && dadosCidade.data.idCidade && dadosCidade.data.idCidade !== '2368' && (
            <LinhaForm style={{ marginTop: 5 }}>
              <FormControl
                type="check2"
                labelCheck="Desejo fazer parte do conselho de usuários."
                nameCheck="ConselhoUsuarios"
                idCheck="checkConselho"
                valueCheck={values.ConselhoOuvidoria}
                changeCheck={() => {
                  setValues({
                    ...values,
                    ConselhoOuvidoria: values.ConselhoOuvidoria === 'S' ? 'N' : 'S',
                  });
                }}
                checked={values.ConselhoOuvidoria === 'S'}
              />
            </LinhaForm>
          )}

          <FormFooter>
            {carregando !== true
              ? (
                <Botao
                  label="Enviar"
                  type="submit"
                  onClick={cadastrarSolicitante}
                />
              )
              : (
                <Carregar />
              )}
          </FormFooter>

        </form>
        )}

      </Interno>
    </Container>
  );
};

export default FormularioUsuarioCadastro;
